<template>
    <v-popover offset="0" :open="isOpen" trigger="manual" :autoHide="true" v-on:auto-hide="close">
        <button class="tooltip-target btn btn-sm btn-link" @click="open" :data-testid="'tasks-state-button-' + taskId">
            <i class="fa fa-2x fa-circle-o text-info" aria-hidden="true" v-if="actualState === 'scheduled'"></i>
            <i class="fa fa-2x fa-check-circle text-success" aria-hidden="true" v-else-if="actualState === 'completed'"></i>
            <i class="fa fa-2x fa-times-circle text-danger" aria-hidden="true" v-else-if="actualState === 'canceled'"></i>
        </button>
        <template slot="popover">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <h4>{{ states[actualState] }}</h4>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <template v-if="actualState === 'scheduled'">
                    <button class="btn btn-danger m-1" @click="changeState('canceled')" :data-testid="'tasks-state-cancel-' + taskId"><i class="fa fa-lg fa-times-circle-o" aria-hidden="true"></i> {{ states.canceled }}</button>
                    <button class="btn btn-success m-1" @click="changeState('completed')" :data-testid="'tasks-state-complete-' + taskId"><i class="fa fa-lg fa-check-circle" aria-hidden="true"></i> {{ states.completed }}</button>
                </template>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <button class="btn btn-sm btn-outline-danger mt-3" @click="close">zavřít</button>
            </div>
        </div>
    </div>
    </template>
    </v-popover>
</template>

<script>
  export default {
    data () {
      return {
        setting: require('../../../variables.js'),
        changePending: false,
        changeError: null,
        task: {},
        isOpen: false,
        states: {
          scheduled: 'nedokončeno',
          completed: 'dokončit',
          canceled: 'zrušit'
        }
      }
    },
    props: ['actualState', 'taskId'],
    methods: {
      changeState (newState) {
        this.changePending = true
        this.task.state = newState
        this.$http.put('task/' + this.taskId, this.task, {emulateJSON: true}).then(response => {
          this.submited = response.data
          this.changePending = false
          this.$emit('update')
          this.close()
          // this.$router.push({name: 'AddAddress', params: { clientid: response.data.id }})
          // this.$route.push()
        }).catch(error => {
          this.changeError = error.response.data.errors
          this.changePending = false
        })
      },
      open () {
        this.isOpen = true
      },
      close () {
        this.isOpen = false
      }
    },
    watch: {
      //
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .input-group.input-group-unstyled input.form-control {
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
    }
    .input-group-unstyled .input-group-addon {
        border-radius: 4px;
        border: 0px;
        background-color: transparent;
    }
    .row_description {
    }
    .row_description > td {
        padding-bottom: 1px;
        border: none;
        font-size: smaller;
    }
    .row_data {
    }
    .row_data > td {
        padding-top: 0px;
        font-weight: bold;
        font-size: large;
        border: none;
    }

    .width_fix {
        width: 100%;
    }
    .label_like {
        max-width: 100%;
        /*font-weight: bold;*/
    }
    .main_attribute {
        max-width: 100%;
        font-size: x-large;
        font-weight: bold;
    }

    .custom_panel_heading {
        border-bottom: none;
        padding-bottom: 0;
        background-color: #b5e3cf;
    }

    .custom_panel_heading .nav-tabs {
        border-bottom: none;
    }

    .custom_panel_heading .nav-tabs > li > a {
        background-color: #fff;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(odd) {
        margin-right: 0;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(even) {
        margin-left: 0;
    }

    /*modal insurance*/

    tr.valid_line {
        font-weight: bold;
    }

    .modal_default {
        overflow: visible !important;
    }

    table.table td {
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/Task/components/TaskChangeState.vue?4bce6d6e